import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import tr from './locales/tr.json';

const resources = {
  en: {
    translation: en
  },
  tr: {
    translation: tr
  }
};

const customLanguageDetector = {
  name: 'customDetector',
  lookup() {
    const userLanguage = localStorage.getItem('userLanguagePreference');
    if (userLanguage) {
      return userLanguage;
    }

    const localStorageLanguage = localStorage.getItem('i18nextLng');
    if (localStorageLanguage && localStorageLanguage !== 'undefined') {
      return localStorageLanguage;
    }

    const browserLanguage = navigator.language || navigator.languages?.[0];
    if (browserLanguage) {
      const langCode = browserLanguage.split('-')[0];
      if (resources[langCode as keyof typeof resources]) {
        return langCode;
      }
    }

    return 'en';
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  }
};

i18n
  .use({
    type: 'languageDetector',
    detect: customLanguageDetector.lookup,
    cacheUserLanguage: customLanguageDetector.cacheUserLanguage,
  })
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },

    supportedLngs: ['en', 'tr'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;